<template>

    <div class="belge-container">
        <div v-if="gelen.hataVarMi">
            {{gelen.mesaj}}
        </div>
        <div v-else>
            <div class="form-alani">
                <b-form autocomplete="off">
                    <div style="margin-bottom: 10px;">
                        <b-button class="ml-1" title="Yazı Boyutunu Azalt" @click="changeFontSize(-1)" size="sm"
                                  variant="outline-info">
                            A
                            <b-icon icon="dash"/>
                        </b-button>
                        <b-button title="Yazı Boyutunu Artır" @click="changeFontSize(1)" size="sm"
                                  variant="outline-info">
                            A
                            <b-icon icon="plus"/>
                        </b-button>
                        <b-button class="btn btn-danger float-right" @click="belgeIadeModalAc">İade Et
                        </b-button>

                        <b-modal id="modal-1"
                                 ref="belgeIadeModal"
                                 title="Belge İade İşlemi"
                                 cancel-title="Vazgeç"
                                 @cancel="iadeVazgeceTikladi"
                                 @ok="belgeIadeTalebiGonder"
                                 ok-title="Gönder">
                            <h5 class="font-weight-bold mb-3">Belgeyi Neden İade Etmek İstiyorsunuz?</h5>
                            <b-form-select
                                    v-model="belgeIadeSebebi"
                                    size="md"
                                    value-field="name"
                                    text-field="name"
                                    :options="iadeSebepler"
                            />
                        </b-modal>

                        <b-button class="float-right" v-b-toggle.collapse-1 variant="info">Durum</b-button>
                        <b-collapse id="collapse-1" class="mt-2">
                            <b-card>
                                <p class="card-text">Durum: <strong>{{intToDurumString(mektup.durum)}}</strong></p>
                                <p class="card-text">Editor İşlemi:
                                    <strong>{{intToIslemString(mektup.editorIslem)}}</strong></p>
                                <p class="card-text">Operatör İşlemi:
                                    <strong>{{intToIslemString(mektup.operatorIslem)}}</strong></p>
                            </b-card>
                        </b-collapse>
                    </div>

                    <b-alert variant="success" show>
                        <b>{{isimGetir(gelen.data.operatorKisi)}}</b> / <b>{{isimGetir(gelen.data.editorKisi)}}</b>
                    </b-alert>

                    <b-form-group id="formIlkElement" label="Mektup Alıcısı" label-for="mektupAlici">
                        <imla v-show="inputIdleri['mektupAlici']" @karakter-yaz="karakterYaz"/>
                        <vue-simple-suggest
                                @focus="onElementFocus('mektupAlici')"
                                v-model="mektup.mektupAlici"
                                ref="mektupAlici" name="mektupAlici" id="mektupAlici"
                                :min-length=1
                                :debounce=500
                                :max-suggestions=10
                                :list="() => oneriListesiniGetir('mektupAlici')"
                        />
                    </b-form-group>

                    <b-form-group label="Çeviri Metin" label-for="ceviriMetin">
                        <imla v-show="inputIdleri['ceviriMetin']" @karakter-yaz="karakterYaz"/>

                        <editor v-if="activeTinyMce"
                                v-model="mektup.ceviriMetin"
                                id="ceviriMetin"
                                ref="ceviriMetin"
                                @onFocus="onElementFocus('ceviriMetin')"
                                api-key="cc3qoh7qpch99vzg4x4hui50fgt5qppa12d63w2z0h8mncjj"
                                :init="{
                                 height: 280,
                                 menubar: false,
                                 setup: function (editor) {
                                    editor.ui.registry.addContextToolbar('textselection', {
                                      predicate: function (node) {
                                        return !editor.selection.isCollapsed();
                                      },
                                      items: 'italic forecolor',
                                      position: 'selection',
                                      scope: 'node'
                                    });
                                  }
                               }"
                        />
                    </b-form-group>

                    <b-form-group label="Esir Numarasi" label-for="esirNumarasi">
                        <b-form-input rows="1" class="w-100"
                                      name="esirNumarasi" id="esirNumarasi" v-model="mektup.esirNumarasi"/>
                    </b-form-group>

                    <b-form-group label="Mektubu Yazan" label-for="mektubuYazan">
                        <imla v-show="inputIdleri['mektubuYazan']" @karakter-yaz="karakterYaz"/>

                        <textarea rows="1" class="w-100"
                                  ref="mektubuYazan" @focus="onElementFocus('mektubuYazan')"
                                  name="mektubuYazan" id="mektubuYazan" v-model="mektup.mektubuYazan"/>
                    </b-form-group>

                    <b-form-group label="Esir Memleketi" label-for="esirMemleketi">
                        <imla v-show="inputIdleri['esirMemleketi']" @karakter-yaz="karakterYaz"/>
                        <vue-simple-suggest
                                @focus="onElementFocus('esirMemleketi')"
                                v-model="mektup.esirMemleketi"
                                :min-length=1
                                ref="esirMemleketi" name="esirMemleketi" id="esirMemleketi"
                                :debounce=500
                                :max-suggestions=10
                                :list="() => oneriListesiniGetir('esirMemleketi')"
                        />
                    </b-form-group>

                    <b-form-group label="Açıklama" label-for="aciklama">
                        <imla v-show="inputIdleri['aciklama']" @karakter-yaz="karakterYaz"/>

                        <textarea rows="3" class="w-100"
                                  ref="aciklama" @focus="onElementFocus('aciklama')"
                                  name="aciklama" id="aciklama" v-model="mektup.aciklama"/>
                    </b-form-group>

                    <kamp-teklif-form />


                    <b-form-group label="Esir Kampı" label-for="esirKampi">
                        <!--
                                            <imla v-show="inputIdleri['esirKampi']" @karakter-yaz="karakterYaz" />
                        -->


                        <v-select
                                :options="kamplar"
                                label="value"
                                :value="kampString"
                                @input="kampSecildiginde"
                                @search="kampListeleriniOner"
                        >

                            <span slot="no-options"></span>

                        </v-select>

                        <b-button
                                class="float-right"
                                size="sm" v-b-modal.yeniKampTeklif>TEKLİF ET</b-button>
                        <div style="clear:both;"></div>
                    </b-form-group>

                    <b-form-group label="Dosya Nu" label-for="dosyaNo">
                        <b-form-input
                                name="dosyaNo" id="dosyaNo" v-model="mektup.dosyaNumarasi"/>
                    </b-form-group>

                    <b-form-group label="Belge Nu" label-for="belgeNo">
                        <b-form-input
                                name="belgeNo" id="belgeNo" v-model="mektup.belgeNumarasi"/>
                    </b-form-group>

                    <b-form-group label="Ek No" label-for="ekNo">
                        <b-form-input
                                name="ekNo" id="ekNo" v-model="mektup.ekNumara"/>
                    </b-form-group>

                    <b-form-group label="Takvim Tipi" label-for="takvimTipi">
                        <b-form-select v-model="mektup.takvimTip" :options="takvim"/>

                    </b-form-group>

                    <b-form-group label="Yıl" label-for="yil">
                        <b-form-input
                                name="yil" id="yil" v-model="mektup.yil"/>
                    </b-form-group>

                    <b-form-group label="Ay" label-for="ay">
                        <b-form-select v-model="mektup.ay" :options="aylar[mektup.takvimTip]"/>
                    </b-form-group>

                    <b-form-group label="Gün" label-for="gun">
                        <b-form-input name="gun" id="gun" v-model="mektup.gun"/>
                    </b-form-group>

                    <b-form-checkbox switch name="kmm" id="kmm"
                                     value="1"
                                     unchecked-value="0"
                                     v-model="mektup.kSeviye">
                        Kıymetli Mektup
                    </b-form-checkbox>

                    <b-form-checkbox switch name="tamamlandi" id="tamamlandi" v-model="tamamlandi">
                        Mektup Tamamlandı
                    </b-form-checkbox>
                    <br style="margin: 30px"/>
                    <b-button
                            v-if="(this.kisi.kisiId===mektup.operatorKisiId && mektup.editorKisiId===0) || this.kisi.kisiId===mektup.editorKisiId"
                            block @click="Kaydet" variant="success">Kaydet
                    </b-button>
                    <b-button v-else>Kayıt Yetkiniz Yok</b-button>

                    <br style="margin: 30px"/>
                </b-form>
            </div>
            <div class="mektup-alani">
                <cropper :img="imgEkstraUrl" @sendCropDetails="okunamayanKelimeEkle"/>
            </div>
        </div>
    </div>

</template>

<script>
    import {mektupGetir, mektupIade, mektupKaydet, mektupResmiGetir} from "@/api/mektup"
    import Cropper from "@/components/Cropper"
    import {mapGetters} from "vuex"
    import {getFontSizeFactor, setFontSizeFactor} from "@/utils/cookie"
    import Imla from "@/components/Imla"
    import VueSimpleSuggest from 'vue-simple-suggest'
    import 'vue-simple-suggest/dist/styles.css'
    import {idyeGoreKampiGetir, kamplariGetir} from "@/api/kamp";
    import {OtomatikTamamlama} from "@/api/autoComplete";
    import {GoogleTokenIleGirisYapmayiDene} from "@/utils/googlegiris";
    import Editor from '@tinymce/tinymce-vue';
    import {okunmayanKelimeEkle} from "@/api/okunamayan";
    import Kisi from "@/views/Kisi";
    import {utilsMixin} from "@/utils/utilsMixin";
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';
    import _ from 'lodash'
    import KampTeklifForm from "@/components/KampTeklifForm"


    export default {
        mixins: [utilsMixin],
        name: "mektup",
        data() {
            return {
                kamplar: [],
                kampString: '',
                activeTinyMce: true,
                tamamlandi: false,
                mektup: {},
                gelen: {
                    hataVarMi: true,
                    mesaj: "Yükleniyor"
                },
                kamp: {},
                lastFocusedElement: 'none',
                imgEkstraUrl: '',
                inputIdleri: {
                    "mektupAlici": false,
                    "ceviriMetin": false,
                    "mektubuYazan": false,
                    "esirMemleketi": false,
                    "aciklama": false,
                },
                fontSizeFactor: 0,
                takvim: [
                    {value: '0', text: 'Miladi'},
                    {value: '1', text: 'Hicri'},
                    {value: '2', text: 'Rumi'}
                ],
                aylar: {
                    0: [
                        {value: '0', text: '-'},
                        {value: '1', text: '1 - Ocak'},
                        {value: '2', text: '2 - Şubat'},
                        {value: '3', text: '3 - Mart'},
                        {value: '4', text: '4 - Nisan'},
                        {value: '5', text: '5 - Mayıs'},
                        {value: '6', text: '6 - Haziran'},
                        {value: '7', text: '7 - Temmuz'},
                        {value: '8', text: '8 - Ağustos'},
                        {value: '9', text: '9 - Eylül'},
                        {value: '10', text: '10 - Ekim'},
                        {value: '11', text: '11 - Kasım'},
                        {value: '12', text: '12 - Aralık'},
                    ],
                    1: [
                        {value: '0', text: '-'},
                        {value: '1', text: '1 - Muharrem'},
                        {value: '2', text: '2 - Safer'},
                        {value: '3', text: '3 - Rebî\'ül-evvel'},
                        {value: '4', text: '4 - Rebî\'ül-âhir'},
                        {value: '5', text: '5 - Cemâziyel evvel'},
                        {value: '6', text: '6 - Cemâziyel âhir'},
                        {value: '7', text: '7 - Receb'},
                        {value: '8', text: '8 - Şâban'},
                        {value: '9', text: '9 - Ramazan'},
                        {value: '10', text: '10 - Şevval'},
                        {value: '11', text: '11 - Zilka\'de'},
                        {value: '12', text: '12 - Zilhicce'},
                    ],
                    2: [
                        {value: '0', text: '-'},
                        {value: '1', text: '1 - Mart'},
                        {value: '2', text: '2 - Nîsan'},
                        {value: '3', text: '3 - Mayıs'},
                        {value: '4', text: '4 - Hazîran'},
                        {value: '5', text: '5 - Temmuz'},
                        {value: '6', text: '6 - Ağustos'},
                        {value: '7', text: '7 - Eylül'},
                        {value: '8', text: '8 - Teşrin-i Evvel'},
                        {value: '9', text: '9 - Teşrin-i Sânî'},
                        {value: '10', text: '10 - Kânûn-ı Evvel'},
                        {value: '11', text: '11 - Kânûn-ı Sânî'},
                        {value: '12', text: '12 - Şubat'},
                    ],
                }
            }
        },
        computed: {
            ...mapGetters([
                'bkCount', 'kisi', 'girisYapmismi'
            ])
        },
        deactivated() {
            this.activeTinyMce = false;
        },
        activated() {
            this.activeTinyMce = true;
        },
        methods: {
            async belgeIadeTalebiGonder() {
                const res = await mektupIade(this.mektup.id, this.belgeIadeSebebi);
                this.belgeIadeSonucKontrol(res, "mektup");
            },

            async kampListeleriniOner(search, loading) {
                loading(true)
                await this.kampAra(loading, search, this);
            },
            kampAra: _.debounce(async (loading, search, vm) => {
                vm.kamplar = await kamplariGetir(search)
                loading(false)
            }, 200),
            kampSecildiginde(selected) {
                if (selected == null){
                    return;
                }
                this.kampString = selected.value
                this.mektup["kampId"] = selected.key
            },
            async oneriListesiniGetir(alanIsmi) {
                const res = await OtomatikTamamlama("Mektup." + alanIsmi, this.mektup[alanIsmi]);
                return res
            },
            changeFontSize(factor) {
                this.fontSizeFactor += factor;

                this.$nextTick(() => {
                    for (let prop in this.inputIdleri) {
                        const el = document.getElementById(prop);
                        if (el instanceof Element) {
                            const style = window.getComputedStyle(el, null).getPropertyValue('font-size');
                            const fontSize = parseFloat(style);
                            el.style.fontSize = (fontSize + factor) + 'px'
                        }
                    }
                });
                setFontSizeFactor(this.fontSizeFactor);
            },
            onElementFocus(ref) {
                this.lastFocusedElement = ref;
                for (let prop in this.inputIdleri) {
                    if (prop === ref)
                        this.inputIdleri[ref] = true;
                    else
                        this.inputIdleri[prop] = false;
                }
                if (this.lastFocusedElement !== "ceviriMetin") {
                    document.getElementsByClassName("tox-editor-header")[0].style.display = "none"
                }
            },
            setCaretPosition(ctrl, pos) {
                // Modern browsers
                if (ctrl.setSelectionRange) {
                    ctrl.focus();
                    ctrl.setSelectionRange(pos, pos);

                    // IE8 and below
                } else if (ctrl.createTextRange) {
                    const range = ctrl.createTextRange();
                    range.collapse(true);
                    range.moveEnd('character', pos);
                    range.moveStart('character', pos);
                    range.select();
                }
            },
            karakterYaz(karakter) {
                if (this.lastFocusedElement === '')
                    return;


                if (this.lastFocusedElement === "ceviriMetin") {
                    const ref = this.$refs[this.lastFocusedElement].editor;
                    ref.insertContent(karakter)
                    return;
                }

                const ref = document.getElementById(this.lastFocusedElement);
                let strPos = ref.selectionStart;
                let strTop = ref.scrollTop;

                let front = this.mektup[this.lastFocusedElement].substring(0, strPos);
                let back = this.mektup[this.lastFocusedElement].substring(strPos, ref.value.length);
                this.mektup[this.lastFocusedElement] = front + karakter + back;
                strPos = strPos + karakter.length;

                this.$nextTick(() => {
                    this.setCaretPosition(ref, strPos);
                    ref.scrollTop = strTop;
                });
            },
            okunamayanKelimeEkle(aciklama, kesmeDetaylari) {
                okunmayanKelimeEkle("mektup", this.mektup.id, aciklama, kesmeDetaylari);


            },
            async Kaydet(e) {
                e.preventDefault();
                
                const key = `mektup-${this.mektup.id}`;
                const guncellenmisMektup = {
                    data: {
                        ...this.mektup
                    }
                };
                localStorage.setItem(key, JSON.stringify(guncellenmisMektup));
                
                const response = await mektupKaydet(this.mektup, this.tamamlandi);
                if (response.hataVarMi) {
                    this.$notify({
                        group: 'ust',
                        type: 'error',
                        title: 'Hata',
                        text: response.mesaj
                    });

                }

                if (response.kod === "kayitedildi") {
                    localStorage.removeItem(key);
                    this.$notify({
                        group: 'ust',
                        title: 'Elhamdülillah',
                        text: response.mesaj
                    });
                }
                if (response.kod === "tamamlandi") {
                    localStorage.removeItem(key);
                    this.$notify({
                        group: 'ust',
                        title: 'Elhamdülillah',
                        text: "Belge Tamamlandı. Yeni belge alabilirsiniz"
                    });
                    setTimeout(async () => {
                        this.$destroy();
                        await this.$router.push("/");
                    }, 3000);

                }

            }
        },
        async mounted() {
            const that = this;
            if (!this.girisYapmismi) {
                await new GoogleTokenIleGirisYapmayiDene(this);
            }

            if (!this.girisYapmismi) {
                this.gelen.mesaj = "Giriş yapmanız lazım";
                this.gelen.hataVarMi = true;

                setTimeout(function () {
                    that.$router.push("/giris-yap?url=" + encodeURI("/mektup"))
                }, 3000);
                return
            }
            
            const key = `mektup-${this.$route.query.id}`;
            if (localStorage.getItem(key)) {
                this.gelen = JSON.parse(localStorage.getItem(key));
            }
            else {
                this.gelen = await mektupGetir(this.$route.query.id);                
            }

            this.mektup = this.gelen.data;
            this.mektup.ceviriMetin = this.mektup.ceviriMetin.replaceAll("<p>", "<p style='font-family: \"Times New Roman\", Times, serif'>");

            this.tamamlandi = this.gelen.data.durum === 1;
            if (this.gelen.hataVarMi) {

                if (this.gelen.kod === "giris-yap") {
                    const that = this;
                    setTimeout(function () {
                        that.$router.push("/giris-yap?url=" + encodeURI(that.gelen.data))
                    }, 1000);
                    return
                }

                return;
            }
            this.imgEkstraUrl = mektupResmiGetir(this.mektup.resimUrl);

            const kamp = await idyeGoreKampiGetir(this.mektup.kampId);
            this.$nextTick(() => {
                this.kampString = kamp.isim
            });

            let val = parseInt(getFontSizeFactor());
            if (isNaN(val)) val = 0;
            this.changeFontSize(val);

            const mektupId = this.mektup.id;

            this.$signalr.on("mektubun-bilinmeyenine-cevap-geldi" + mektupId, (msj) => {
                this.$notify({
                    group: 'ust',
                    type: 'success',
                    title: 'Sorduğunuz Kelimeye Cevap Geldi',
                    text: msj.metin,
                    duration: 5000
                });
            })
        },
        created() {

        },

        components: {
            Imla,
            Cropper,
            VueSimpleSuggest,
            'editor': Editor,
            vSelect,
            KampTeklifForm
        },
    }
</script>

<style lang="scss">
    .tox-editor-header {
        display: none;
    }

    .tox .tox-statusbar {
        display: none !important;
    }

    .belge-container {
        height: 100%;
        @media (max-width: 500px) {
            height: calc(100% - 120px);
        }
        width: 100%;
        position: relative;
    }

    .form-alani {
        font-family: "Times New Roman", Times, serif;
        position: absolute;
        padding: 10px;
        left: 0;
        height: 100%;
        @media (min-width: 500px) {
            height: 100%;
        }
        width: 50%;
        max-height: inherit;
        @media (max-width: 800px) {
            height: 50%;
            width: 100%;
            bottom: 0px;
        }

        @media all and (device-width: 834px) and (device-height: 1112px) {
            height: 50%;
            width: 100%;
            bottom: 0px;
        }

        #okunamayanlar {
            @media (min-width: 500px) {
                display: none;
            }
        }

        form {
            height: 100%;
            overflow-y: scroll;
            @media (max-width: 500px) {
                margin-top: 0px;
            }

            #formIlkElement {
                @media (max-width: 500px) {
                }
            }
        }

        textarea {
            border: 1px solid #ced4da;
        }
    }

    .mektup-alani {
        position: absolute;
        right: 0;
        height: 100%;
        width: 50%;
        background-color: #eeeeee;
        @media (max-width: 800px) {
            height: 50%;
            width: 100%;
        }

        @media all and (device-width: 834px) and (device-height: 1112px) {
            height: 50%;
            width: 100%;
        }
    }

    input {
        width: 400px;
        height: 44px;
        padding: 0 16px;
        font-size: 24px;
    }

</style>
